import {
  createFileRoute,
  Outlet,
  useLocation,
  useNavigate,
} from "@tanstack/react-router";
import { useEffect, useState } from "react";

import PublicLayout from "@/components/ui/layout/public-layout";
import { useVendorOnboarding } from "@/features/vendor/onboarding/v1/_hooks/use-vendor-onboarding";

export const Route = createFileRoute("/vendors/onboarding/v1")({
  component: RouteComponent,
  head: () => ({
    meta: [
      { title: "Birdwatch - Vendor Onboarding" },
      { name: "description", content: "Birdwatch - Vendor Onboarding" },
    ],
  }),
});

function RouteComponent() {
  const navigate = useNavigate();
  const pathname = useLocation({
    select: (location) => location.pathname,
  });
  const { step } = useVendorOnboarding();
  const currentStep = step;
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    if (isMounted) {
      return;
    }
    setIsMounted(true);
    if (currentStep !== pathname) {
      navigate({ to: currentStep });
    }
  }, []);

  if (!isMounted) {
    return null;
  }

  return (
    <PublicLayout>
      <Outlet />
    </PublicLayout>
  );
}
